import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { ServerCard, Server } from '../components/ServerCard';
import { PlusIcon, FileTextIcon, ServerIcon } from 'lucide-react';
const mockServers: Server[] = [{
  id: 'srv_8x7k2m9p',
  name: 'Production API Gateway',
  endpoint: 'https://mcp.example.com/v1/gateway',
  status: 'healthy',
  policyMode: 'Default deny',
  allowedTools: 12,
  lastActivity: '2 min ago',
  blockedRequests24h: 3
}, {
  id: 'srv_3n5j8w2q',
  name: 'Data Processing Pipeline',
  endpoint: 'https://mcp.example.com/v1/pipeline',
  status: 'healthy',
  policyMode: 'Default deny',
  allowedTools: 8,
  lastActivity: '15 min ago',
  blockedRequests24h: 0
}, {
  id: 'srv_9m4k1p6r',
  name: 'Analytics Service',
  endpoint: 'https://mcp.example.com/v1/analytics',
  status: 'degraded',
  policyMode: 'Default deny',
  allowedTools: 5,
  lastActivity: '1 hour ago',
  blockedRequests24h: 47
}, {
  id: 'srv_2w8n5t3v',
  name: 'Legacy Integration',
  endpoint: 'https://mcp.example.com/v1/legacy',
  status: 'offline',
  policyMode: 'Default deny',
  allowedTools: 3,
  lastActivity: '3 days ago',
  blockedRequests24h: 0
}];
export function Servers() {
  return <div data-id="element-432">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-433">
        <div data-id="element-434">
          <h1 className="text-xl font-semibold text-slate-900 dark:text-slate-100" data-id="element-435">
            Servers
          </h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5" data-id="element-436">
            MCP servers protected by MCPGuard
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-437">
          <Link to="/audit" data-id="element-438">
            <Button variant="secondary" size="md" data-id="element-439">
              <FileTextIcon className="h-4 w-4 mr-2" data-id="element-440" />
              View Audit Logs
            </Button>
          </Link>
          <Link to="/servers/new" data-id="element-441">
            <Button variant="primary" size="md" data-id="element-442">
              <PlusIcon className="h-4 w-4 mr-2" data-id="element-443" />
              Add Server
            </Button>
          </Link>
        </div>
      </div>

      {/* Server Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-444">
        {mockServers.map(server => <ServerCard key={server.id} server={server} data-id="element-445" />)}
      </div>

      {/* Empty State */}
      {mockServers.length === 0 && <div className="text-center py-12" data-id="element-446">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-slate-100 dark:bg-slate-800 mb-4" data-id="element-447">
            <ServerIcon className="h-6 w-6 text-slate-400 dark:text-slate-500" data-id="element-448" />
          </div>
          <h3 className="text-sm font-medium text-slate-900 dark:text-slate-100 mb-1" data-id="element-449">
            No servers configured
          </h3>
          <p className="text-sm text-slate-500 dark:text-slate-400 mb-4" data-id="element-450">
            Get started by adding your first MCP server.
          </p>
          <Link to="/servers/new" data-id="element-451">
            <Button variant="primary" data-id="element-452">
              <PlusIcon className="h-4 w-4 mr-2" data-id="element-453" />
              Add Server
            </Button>
          </Link>
        </div>}
    </div>;
}